/*

事情是这样的，这个拿类目的接口不是独立的，那么存在两种情况，推荐页可以拿到类目接口(包括大小类)和其他信息的接口，
普通页也可以拿到一次，不能只拿一次，除非存起来，但是太麻烦了管理这个状态，我想还是拿了之后统一通过globalBus 传递和管理
这样不会乱

*/

import * as React from 'react'
import * as CategoryMenuItemStyle from './CategoryMenuItem.style'
import {classes} from 'typestyle'
import CategoryType from '../../../Category/type/CategoryType'
import globalBus from '@/services/Bus'
import {isPC, getJsonFromUrl } from '@/utils/tools'
import { RegisterElement } from '@/services/hotspotReport'
import { reportClickEvent } from '../../../../services/operationReport'
declare const document: any

interface CategoryMenuItemProps {
    content: {
        name: string,
        sub_categories: CategoryType.SubCategory[]
    },
    changeCategoryId: (selectCid: number, type?: string) => void
}

interface CategoryMenuItemState {
    selectIndex: number,
    isOverFlow: boolean,
    isFixed: boolean
}

export default class CategoryMenuItem extends React.Component <CategoryMenuItemProps, CategoryMenuItemState> {
    private CategoryRef: React.RefObject<HTMLDivElement>
    constructor(props: CategoryMenuItemProps) {
        super(props)
        this.state = {
            selectIndex: 0,
            isOverFlow: false,
            isFixed: false
        }
        this.CategoryRef = React.createRef()
        globalBus.bindComponent(this, {
            categorySelectId: (categorySelectId) => {
                this.setState({
                    selectIndex: categorySelectId
                })
            }
           }
        )
    }

    public componentDidMount() {
        const sub_categories = this.props.content.sub_categories
        const categoryId = parseFloat(getJsonFromUrl().id)
        const CategoryArray: number[] = []
        window.addEventListener('scroll', this.handleScroll)
        sub_categories.map((v) => {
          CategoryArray.push(v.id)
        })
        if (CategoryArray.indexOf(categoryId) > -1) {
            if (CategoryArray.indexOf(categoryId) >= 3) {
                this.setState({
                    isOverFlow: true
                }, () => {
                    if (this.state.isOverFlow) {
                        if (document.getElementById('MenuScrollRefs') && document.getElementById('MenuScrollRefs') !== null) {
                            document.getElementById('MenuScrollRefs').scrollLeft = 250
                        }
                    }
                })
            }
            this.setState({
                selectIndex: categoryId
            })
        } else {
            this.setState({
                selectIndex: sub_categories[0].id
            })
        }
    }

    public changeType = (val: number, event: any) => {
        if (val === 0) {
            this.props.changeCategoryId(event.currentTarget.getAttribute('data-pid'), 'recommend')
            reportClickEvent(RegisterElement.category_bar, {object_type: window.sessionStorage.getItem('HOMEPAGE/CATEGORY_SELECT/CATEGORYNAME'), object_id: parseInt(event.currentTarget.getAttribute('data-cid'), 10)})
            return
        }
        this.props.changeCategoryId(val)
        reportClickEvent(RegisterElement.category_bar,  {object_type: window.sessionStorage.getItem('HOMEPAGE/CATEGORY_SELECT/CATEGORYNAME'), object_id: parseInt(event.currentTarget.getAttribute('data-cid'), 10)})
    }

    public componentWillReceiveProps(nextProps) {
       if (/recommend/.test(window.location.search)) {
          this.setState({
              selectIndex: 0
          })
       }
    }

    public handleScroll = () => {
        if (this.CategoryRef.current && this.CategoryRef.current !== null) {

            if (document.body.scrollTop + document.documentElement.scrollTop >= 42) {
                if (!this.state.isFixed) {
                    this.setState({
                        isFixed: true
                    })
                }
            } else {
                if (this.state.isFixed) {
                    this.setState({
                        isFixed: false
                    })
                }
            }
        }
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    public render() {
        const {selectIndex} = this.state
        return (
            <div className={classes(CategoryMenuItemStyle.CategoryMenuItem, this.state.isFixed && CategoryMenuItemStyle.categoryMenuFixed)} ref={this.CategoryRef}>
                <div id="MenuScrollRefs" className={classes(CategoryMenuItemStyle.slideMenu, isPC() ? CategoryMenuItemStyle.slideMenuIfPc : null)}>
                        {this.props.content.sub_categories.map((v: CategoryType.SubCategory, index) => (
                            <div
                                style={{display: 'table'}}
                                className={classes(CategoryMenuItemStyle.slideMenuItem, selectIndex === v.id ? CategoryMenuItemStyle.seletctActive : null)}
                                data-cid={v.id}
                                data-cname={v.name}
                                data-index={index}
                                data-pid={v.parent_id}
                                key={index}
                                onClick={this.changeType.bind(this, v.id)}
                            >
                                {v.name}
                            </div>
                        ))}
                        <div style={{padding: '0 0 0 15px'}}/>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryMenuItem/CategoryMenuItem.tsx